import { render } from "./StoreIcon.vue?vue&type=template&id=13c23dd1&scoped=true"
import script from "./StoreIcon.vue?vue&type=script&lang=js"
export * from "./StoreIcon.vue?vue&type=script&lang=js"

import "./StoreIcon.vue?vue&type=style&index=0&id=13c23dd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c23dd1"]])

export default __exports__